import createContext from './createContext';

export default function getContext(ctx, props) {
  const state = props && props.$state;
  return createContext(ctx, state);
}
